<!-- Toast with dynamic styling based on type input -->
<p-toast position="top-right" [life]="3000" [key]="key" [ngClass]="'toast-style-' + type">
	<ng-template let-message pTemplate="message">
		<!-- Icon in a rounded square tinted with the type colour -->
		<span class="p-toast-message-icon bt-toast-icon">
			@switch (message.severity) {
				@case ('success') {
					<lucide-icon name="CircleCheck" [size]="20"></lucide-icon>
				}
				@case ('warn') {
					<lucide-icon name="TriangleAlert" [size]="20"></lucide-icon>
				}
				@case ('error') {
					<lucide-icon name="CircleX" [size]="20"></lucide-icon>
				}
				@default {
					<lucide-icon name="Info" [size]="20"></lucide-icon>
				}
			}
		</span>
		<div class="p-toast-message-text">
			@if (message.summary) {
				<span class="p-toast-summary">{{ message.summary }}</span>
			}
			@if (message.detail) {
				<div class="p-toast-detail">{{ message.detail }}</div>
			}
		</div>
	</ng-template>
</p-toast>
